/**
 * Mentoras del taller - TNO Academy
 */
export const mentorsData = [
  {
    name: 'Margarita Toledo',
    role: 'Comunicadora social y locutora',
    bio: `Comunicadora social y locutora egresada de la Universidad Santa María, con una trayectoria de 27 años forjada en las áreas de sucesos, comunidad y fuente militar.

Mi carrera comenzó en la redacción de El Observador de RCTV, donde durante cinco años aprendí el rigor de la noticia inmediata. Posteriormente, me desempeñé durante una década como reportera de trabajos especiales en Televen, formando parte del equipo de investigación de 100% Venezuela. También he tenido el honor de llevar la información a través de las ondas de Unión Radio.

A lo largo de este camino, mi trabajo ha sido reconocido con galardones por reportajes como "Un día en la vida de" y "No le da pena". Poseo una sólida experiencia en todos los géneros periodísticos y de opinión, con dominio integral en la preproducción, producción y postproducción de contenidos informativos.

Tras años en la primera línea informativa, hoy canalizo mi experiencia en la producción y conducción de "Punto de Fe" a través de TNO Network. En este programa, busco inspirar a mi audiencia conectando con la fe y la convicción de que, con un ser supremo como guía, no existen imposibles. Soy una experta en la creación de contenidos desde la idea inicial hasta la postproducción, siempre con el objetivo de informar y transformar vidas.`,
    initials: 'MT',
    image: '/images/Margarita Toledo Punto de Fe-Programa..png',
    link: 'https://www.tnonetwork.com/show/puntodefe',
  },
  {
    name: 'Yelitza Yánez (Yeyé)',
    role: 'Periodista, especialista en Inbound Marketing & Branded Content',
    bio: `Con 28 años de experiencia, he aprendido que el periodismo no solo se trata de informar, sino de conectar. Soy egresada de la UCV y especialista en Inbound Marketing & Branded Content, una combinación que me permite ofrecer una visión 360° en redacción, edición y asesoría estratégica.

Mi trabajo va más allá del reporteo; me apasiona estructurar procesos editoriales y mejorar las dinámicas de trabajo en medios digitales. Hoy, pongo esa experiencia al servicio de marcas en las áreas de salud, medicina, negocios y gastronomía, creando contenidos que realmente resuenan con su audiencia.

La radio y el podcasting son mi hogar creativo. No solo los produzco y asesoro, sino que comparto ese conocimiento como profesora en la Universidad Católica Andrés Bello. Actualmente, me puedes escuchar y leer en:

somospadres.info: Magazine en TNO Network y revista digital.
Después del Evento: Podcast en TNO Network y en el canal de YouTube @ReporterasTV.`,
    initials: 'YY',
    image: '/images/Yelitza Yeye Yanez-SomosPadresInfo.png',
    link: 'https://somospadres.info',
  },
];
